// @flow
import './TextBox.css';

import * as React from 'react';
import classNames from 'classnames';
import Button from '../Button';
import ToolTip from '../AssetPropertyView';

type Props = {
  value: ?string,
  onChange?: (a: Event) => void,
  className?: string,
  clearable?: boolean,
  disabled?: boolean,
  size?: string,
  onFocus?: Function,
  onBlur?: Function,
  __data?: Object
};

export default class TextBox extends React.Component<Props, {}> {
  static defaultProps = {
    clearable: true,
    size: 'SMALL',
    focusOnClear: true
  };

  node: ?HTMLInputElement;
  button: ?Button;

  onClick = () => {
    this.node.value = '';
    const e = document.createEvent('Event');
    e.initEvent('change', true, true);
    this.node.dispatchEvent(e);

    this.props.onChange(e);
    if (this.props.focusOnClear) {
      this.node.focus();
    }
  };

  onBlur = () => {
    this.node.blur();
  };

  render() {
    const {
      clearable,
      className,
      textOverFlowEllipsis,
      focusOnClear,
      disabled,
      size,
      __data,
      editable,
      fromComponent,
      ...rest
    } = this.props;
    const inputStyleClass = textOverFlowEllipsis ? 'overflow-ellipsis' : '';
    return (
      <div
        name="TextBox"
        className={classNames(className, {
          clearable: clearable && !disabled,
          [`size-${size.toLowerCase()}`]: true
        })}>
        <ToolTip style={{ height: '100%' }} toolTipStyle text={this.props.value}>
          <input
            className={inputStyleClass}
            type="text"
            disabled={disabled}
            {...rest}
            ref={(node) => (this.node = node)}
          />
        </ToolTip>
        {fromComponent != 'TimelinePopup' && !disabled && clearable ? (
          <Button icon="images/cross_gray.svg" onClick={this.onClick} ref={(inst) => (this.button = inst)} />
        ) : null}
      </div>
    );
  }
}
